import type { GetServerSideProps } from "next";

import { loadPageWithGlobal } from "@shared/api";

import { getTicketsPage } from "@/_pages/tickets/api";
import type {
  TicketsPageType,
  TicketsType,
  TicketTypesType,
} from "@/_pages/tickets/model";
import { TicketsPage } from "@/_pages/tickets/ui";

type PageProps = {
  cms: {
    filters: TicketTypesType[];
    tickets: TicketsType;
    pageData: TicketsPageType;
  };
};

const Page = (props: PageProps) => {
  const {
    cms: { filters, tickets, pageData },
  } = props;

  return (
    <TicketsPage filters={filters} tickets={tickets} pageData={pageData} />
  );
};

export const getServerSideProps: GetServerSideProps<PageProps> = async (
  context,
) => {
  const { res } = context;
  const typeParam = context.query?.type;
  const initialType =
    typeof typeParam === "string" && typeParam.length > 0 ? typeParam : "all";

  const result = await loadPageWithGlobal(
    async () => {
      return {
        ...(await getTicketsPage()),
      };
    },
    { res },
  );

  if ("props" in result) {
    const baseProps = result.props;
    const cms = baseProps.cms;

    // Если в query есть type, переопределяем стартовый список билетов под этот тип
    let tickets: TicketsType = cms.tickets;

    if (initialType !== "all") {
      const filtered = await import(
        "@/_pages/tickets/api/getCurrentTickets"
      ).then((m) => m.getCurrentTickets);
      tickets = await filtered(initialType, 1);
    }

    return {
      ...result,
      props: {
        ...baseProps,
        cms: {
          ...cms,
          tickets,
        },
      },
    };
  }

  return result;
};

export default Page;
